import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { importMetaEnv } from '~sf/constants';

export const fetchLDProvider = async () =>
  asyncWithLDProvider({
    clientSideID: importMetaEnv.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID,
    context: {
      kind: 'user',
      key: 'anonymous-user',
      anonymous: true,
    },
  });
